import PlayBadge from 'app/ui-components/PlayBadge/PlayBadge';
import PropTypes from 'prop-types';
import placeHolderImage from 'public/static//images/placeholders/16_9.png';
import React from 'react';
import CONTENTO_PRESENTATION_TYPES from '../../../../domain/ContentoPresentationTypes';
import { formatImageProxyUrl, formatUrl, isImageProxyTemplate } from '../../../../utils/svtimage';
import EditMode from '../EditMode/EditMode';
import { StyledContentItemFigure, StyledPlayIcon } from './ContentItemFigure.styles';

const ContentItemFigure = (props) => {
    const {
        content,
        defaultImage,
        showPlaceholder,
        preferThumbnail,
        presentation,
        editModeActivated,
        markedAsDeleted,
        autoPlayOverlay,
    } = props;

    const { onlyAvailableInSweden, imageAltText } = content;

    let image;
    let imageTemplate;
    if (preferThumbnail) {
        imageTemplate = content.thumbnail || content.poster || content.image;
    } else {
        imageTemplate = content.poster || content.thumbnail || content.image;
    }

    let imageFormat;
    let imageRatio;
    let imageRatioType;

    if (presentation === CONTENTO_PRESENTATION_TYPES.PORTRAIT) {
        imageFormat = 'twothree';
        imageRatioType = '2-3';
    } else {
        imageFormat = 'wide';
    }

    if (isImageProxyTemplate(imageTemplate)) {
        image = imageTemplate
            ? formatImageProxyUrl(imageTemplate, imageFormat, 480, imageRatio)
            : defaultImage;
    } else {
        image = imageTemplate ? formatUrl(imageTemplate, 'medium') : defaultImage;
    }

    const opacity = editModeActivated ? '0.1' : undefined;

    return (
        <>
            <StyledContentItemFigure
                src={showPlaceholder || !image ? placeHolderImage : image}
                alt={imageAltText}
                imageRatio={imageRatioType}
                blurred={opacity ? false : onlyAvailableInSweden}
                showPlaceholder={showPlaceholder}
                opacity={opacity}
                onlyAvailableInSweden={onlyAvailableInSweden}
                editModeActivated={editModeActivated}
            >
                {autoPlayOverlay && <StyledPlayIcon onlyAvailableInSweden={onlyAvailableInSweden} />}
                {content.badge && !editModeActivated && (
                    <PlayBadge
                        text={content?.badge?.text}
                        theme={content?.badge?.type}
                        accessibilityText={content?.badge?.altText}
                        overlay
                    />
                )}
                {editModeActivated && (
                    <EditMode markedAsDeleted={markedAsDeleted} programTitle={content.programTitle} />
                )}
            </StyledContentItemFigure>
        </>
    );
};

ContentItemFigure.propTypes = {
    content: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        poster: PropTypes.string,
        image: PropTypes.string,
        thumbnail: PropTypes.string,
        isLive: PropTypes.bool,
        broadcastedNow: PropTypes.bool,
        broadcastEnded: PropTypes.bool,
        onlyAvailableInSweden: PropTypes.bool,
        video: PropTypes.bool,
        savedPosition: PropTypes.number,
    }),
    defaultImage: PropTypes.string,
    showPlaceholder: PropTypes.bool,
    preferThumbnail: PropTypes.bool,
    fadeOut: PropTypes.bool,
    transparent: PropTypes.bool,
    location: PropTypes.string,
    presentation: PropTypes.string,
    showBadges: PropTypes.bool,
    editModeActivated: PropTypes.bool,
};

ContentItemFigure.defaultProps = {
    showBadges: true,
};

export default ContentItemFigure;
